<div class="d-flex flex-wrap gap-4">
  <app-mdb-button [text]="'EMPLOYEES.NEW_EMPLOYEE'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewEmployeeModal()" />
</div>

<app-employees-table/>
